export const audienceSyncConsumption =
  "/analytics_dashboard/:app_group_id/audience_sync_credit_consumption_detail_data";
